import React, { useRef } from 'react';
import { articleTilePropTypes } from './ArticleTilePropTypes';
import Picture from './components/Picture/Picture';
import Details from './components/Details/Details';
import * as styles from './ArticleTile.module.scss';
const ArticleTile = ({
  picture,
  category,
  date,
  heading,
  href,
  description,
  isLarge
}) => {
  const articleLink = useRef(null);
  const handleOnClick = event => {
    if (event.target.tagName !== 'A') {
      event.preventDefault();
      window.location.href = articleLink.current.href;
    }
  };
  const rootClass = `${styles.root} ${!isLarge ? styles.rootSmall : ''}`;
  return /*#__PURE__*/React.createElement("div", {
    onClick: handleOnClick,
    className: rootClass
  }, isLarge && /*#__PURE__*/React.createElement(Picture, Object.assign({}, picture, {
    imgClassname: styles.rootImage
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rootContent
  }, (category || date) && /*#__PURE__*/React.createElement(Details, {
    isLarge: isLarge,
    category: isLarge && category,
    date: date
  }), heading && /*#__PURE__*/React.createElement("a", {
    href: href,
    className: styles.rootHeading,
    ref: articleLink
  }, heading), isLarge && description && /*#__PURE__*/React.createElement("p", {
    className: styles.rootDescription
  }, description)));
};
export default ArticleTile;